import React, { useState, useMemo, useContext, createContext } from "react";
import PropTypes from "prop-types";
import { PromoState } from "../../globals";

const PromoContext = createContext({
  promoState: PromoState.LOADING,
  setPromoState: () => {}
});

export const usePromoContext = () => useContext(PromoContext);

export const PromoProvider = ({ children }) => {
  const [promoState, setPromoState] = useState(PromoState.LOADING);

  const contextValue = useMemo(
    () => ({
      promoState,
      setPromoState
    }),
    [promoState, setPromoState]
  );

  return (
    <PromoContext.Provider value={contextValue}>
      {children}
    </PromoContext.Provider>
  );
};

PromoProvider.propTypes = {
  children: PropTypes.node
};
